angular.module("survey").factory("queryParser", [queryParser])

function queryParser() {
  var parsedQueries = {}
  return function(queryString) {
    if (parsedQueries[queryString]) {
      return Object.assign({}, parsedQueries[queryString]);
    }
    var params = {},
        match,
        search = /([^&=]+)=?([^&]*)/g,
        query  = queryString.substring(1);
    function decode(s) {
      try {
        return decodeURIComponent(s)
      } catch(err) {
        return s
      }
    }
    while (match = search.exec(query))
      params[decode(match[1])] = decode(match[2]);

    // memoize so we don't have to do this repeatedly
    parsedQueries[queryString] = Object.assign({}, params);

    return params
  }
}